/**
 * @author Leonel Martinez 
 * @fileoverview Axios instances
 * @see axios @ https://github.com/axios/axios
 * @see retryInterceptor @ https://github.com/flexdinesh/axios-retry-interceptor
 */
import axios from 'axios';

const provider = window.location.href.match(/#\/[\w-]+/i)[0].replace('#/', '');
console.log('Provider:', provider);

// Instance for all estore endpoints
export const http = axios.create({ baseURL: `${process.env.VUE_APP_SERVICE_MFR}/${provider}/` })

// Log interceptors for request and response to API
if (process.env.VUE_APP_CONSOLE_REQUESTS_LOG === "true") {
  http.interceptors.request.use(request => {
    // var url = request.url.indexOf(request.baseURL) > -1 ? request.url : request.baseURL + request.url;
    // var data = request.data ? { params: request.data, json: JSON.stringify(request.data) } : "No body params for request";
    // console.log('Request: ', url, data);
    return request;
  });

  http.interceptors.response.use(response => {
    // var data = response.data ? { result: response.data, json: JSON.stringify(response.data) } : "No response data";
    // console.log('Response: ', response.request.responseURL, response.statusText, data);
    return response;
  });
}
